<template>
    <div class="ipv6-cidr">
        <div class="sdiv">
            <input type="text" class="inputMode tcenter" v-model="cidr1Val" disabled="true">
        </div>
        <div class="select-box ml20 cidrSelectBox">
            <el-input type="text"  v-model="cidr2Val" :maxlength="1" @blur="checkIpv6Cidr">
            </el-input>
        </div>
        <span class="stext">::/</span>
        <div class="sdiv">
            <input type="text" class="inputMode tcenter" v-model="cidr3Val" :disabled="true">
        </div>
        <p v-if="showTips" class="jc-form-item__error">{{$t('subnet.tooltip.ipv6CidrError')}}</p>
    </div>
</template>

<script>
let ipv6CidrReg = /^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$|^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*\/(1[01][0-9]|12[0-8]|[0-9]{1,2})$/;
export default {
    name: 'Ipv6Cidr',
    data() {
        return {
            cidr1Val: '',
            cidr2Val: 0,
            cidr3Val: '',
            showTips: false
        };
    },
    props: {
        cidrArray: {
            type: Array,
            default: () => [10, 0, 0]
        },
    },
    watch: {
        // cidr2Val() {
        //     if (!this.showTips) {
        //         this.emitCidrVal();
        //     }            
        // },
        cidrArray() {
            this.syncCidrVal();
        }
    },
    methods: {

        /**
           **@disc:同步父组件传递进来的cidr值
           **@params:none
        */
        syncCidrVal() {
            [this.cidr1Val, this.cidr2Val, this.cidr3Val] = this.cidrArray;
        },
        /**
           **@disc:将子组件中修改的值发射给父组件
           **@params:none
        */
        emitCidrVal() {
            this.$emit('ipv6CidrVal', [this.cidr1Val, this.cidr2Val, this.cidr3Val, !this.showTips]);
        },

        checkIpv6Cidr() {
            let ipv6Cidr = this.cidr1Val + this.cidr2Val + "::/" + this.cidr3Val;
            let validIpv6Cidr = ipv6CidrReg.test(ipv6Cidr);
            if (validIpv6Cidr && this.cidr2Val !== '') {
                this.showTips = false;
            } else {
                this.showTips = true;
            }
            this.emitCidrVal();
        }
    }
};
</script>

<style lang="scss">
  @import 'style';
</style>



// WEBPACK FOOTER //
// src/components/subnet/ipv6Cidr/Ipv6Cidr.vue